import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import pb from '../../lib/pocketbase';

export default function AdminSalesTeamPage() {
    const [agents, setAgents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editingAgent, setEditingAgent] = useState(null);

    // Form State
    const [formData, setFormData] = useState({});

    const fetchAgents = async () => {
        setLoading(true);
        try {
            const res = await pb.collection('commercial_profiles').getList(1, 100, {
                sort: '-created',
                expand: 'user'
            });
            setAgents(res.items);
        } catch (err) {
            console.error("Error fetching agents:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAgents();
    }, []);

    const handleEdit = (agent) => {
        setEditingAgent(agent);
        setFormData({
            firstname: agent.firstname,
            lastname: agent.lastname,
            email: agent.email,
            phone: agent.phone,
            city: agent.city,
            specialty: agent.specialty,
            level: agent.level,
            xp: agent.xp,
            bio: agent.bio
        });
    };

    const handleClose = () => {
        setEditingAgent(null);
        setFormData({});
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            await pb.collection('commercial_profiles').update(editingAgent.id, formData);
            setEditingAgent(null);
            fetchAgents(); // Refresh list
        } catch (err) {
            alert("Erreur: " + err.message);
        }
    };

    return (
        <AdminLayout title="Équipe Commerciale">
            <div style={{ padding: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                    <h1>Commerciaux & Agents ({agents.length})</h1>
                    <button onClick={fetchAgents} style={{ padding: '8px 16px', background: 'var(--admin-panel)', border: '1px solid var(--admin-border)', borderRadius: 8, cursor: 'pointer', color: 'inherit' }}>
                        Actualiser
                    </button>
                </div>

                {loading ? (
                    <div>Chargement...</div>
                ) : (
                    <div className="table-container" style={{ overflowX: 'auto', background: 'var(--admin-panel)', borderRadius: 12, border: '1px solid var(--admin-border)' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 800 }}>
                            <thead>
                                <tr style={{ borderBottom: '1px solid var(--admin-border)', textAlign: 'left', background: 'rgba(0,0,0,0.02)' }}>
                                    <th style={{ padding: 12 }}>Agent</th>
                                    <th style={{ padding: 12 }}>Identité</th>
                                    <th style={{ padding: 12 }}>Info Contact</th>
                                    <th style={{ padding: 12 }}>Spécialité</th>
                                    <th style={{ padding: 12 }}>Niveau</th>
                                    <th style={{ padding: 12 }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {agents.map(agent => (
                                    <tr key={agent.id} style={{ borderBottom: '1px solid var(--admin-border)' }}>
                                        <td style={{ padding: 12 }}>
                                            <div style={{ width: 40, height: 40, borderRadius: '50%', overflow: 'hidden', background: '#334155', border: '1px solid var(--admin-border)' }}>
                                                {agent.photo ? (
                                                    <img src={pb.files.getUrl(agent, agent.photo)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                ) : (
                                                    <div style={{ width: '100%', height: '100%', display: 'grid', placeItems: 'center' }}>👤</div>
                                                )}
                                            </div>
                                        </td>
                                        <td style={{ padding: 12 }}>
                                            <div style={{ fontWeight: 600 }}>{agent.lastname} {agent.firstname}</div>
                                            <div style={{ fontSize: '0.8rem', opacity: 0.6 }}>ID: {agent.user}</div>
                                        </td>
                                        <td style={{ padding: 12 }}>
                                            <div style={{ fontSize: '0.9rem' }}>{agent.email}</div>
                                            <div style={{ fontSize: '0.8rem', opacity: 0.7 }}>{agent.phone}</div>
                                            <div style={{ fontSize: '0.8rem', opacity: 0.7 }}>{agent.city}</div>
                                        </td>
                                        <td style={{ padding: 12 }}>
                                            <span style={{
                                                padding: '4px 10px', borderRadius: 20, fontSize: '0.8rem', fontWeight: 600,
                                                background: agent.specialty === 'Expert Digital' ? 'rgba(59, 130, 246, 0.1)' : (agent.specialty === "Chargé d'Affaires" ? 'rgba(16, 185, 129, 0.1)' : 'rgba(148, 163, 184, 0.1)'),
                                                color: agent.specialty === 'Expert Digital' ? '#3b82f6' : (agent.specialty === "Chargé d'Affaires" ? '#10b981' : '#94a3b8')
                                            }}>
                                                {agent.specialty || '-'}
                                            </span>
                                        </td>
                                        <td style={{ padding: 12 }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                <div style={{ fontWeight: 700 }}>Niv. {agent.level}</div>
                                                <div style={{ fontSize: '0.8rem', opacity: 0.6 }}>({agent.xp} XP)</div>
                                            </div>
                                            <div style={{ width: 60, height: 4, background: 'rgba(255,255,255,0.1)', borderRadius: 2, marginTop: 4 }}>
                                                <div style={{ width: `${Math.min(agent.xp, 100)}%`, height: '100%', background: '#3b82f6' }} />
                                            </div>
                                        </td>
                                        <td style={{ padding: 12 }}>
                                            <button onClick={() => handleEdit(agent)} style={{ padding: '6px 12px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: 6, fontSize: '0.85rem', cursor: 'pointer' }}>
                                                Modifier
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                {agents.length === 0 && (
                                    <tr>
                                        <td colSpan={6} style={{ padding: 40, textAlign: 'center', opacity: 0.5 }}>Aucun agent trouvé.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* EDIT MODAL */}
            {editingAgent && (
                <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 100, display: 'grid', placeItems: 'center' }} onClick={handleClose}>
                    <div style={{ background: 'var(--admin-panel)', width: 500, maxWidth: '90%', borderRadius: 12, padding: 30, border: '1px solid var(--admin-border)', boxShadow: '0 20px 50px rgba(0,0,0,0.3)' }} onClick={e => e.stopPropagation()}>
                        <h2 style={{ marginTop: 0, marginBottom: 20 }}>Modifier le Profil Agent</h2>
                        <form onSubmit={handleSave}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                                <div>
                                    <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.7, marginBottom: 4 }}>Nom</label>
                                    <input name="lastname" value={formData.lastname || ''} onChange={handleChange} style={inputStyle} />
                                </div>
                                <div>
                                    <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.7, marginBottom: 4 }}>Prénom</label>
                                    <input name="firstname" value={formData.firstname || ''} onChange={handleChange} style={inputStyle} />
                                </div>
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                                <div>
                                    <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.7, marginBottom: 4 }}>Tel</label>
                                    <input type="text" inputMode="tel" name="phone" value={formData.phone || ''} onChange={handleChange} style={inputStyle} />
                                </div>
                                <div>
                                    <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.7, marginBottom: 4 }}>Ville</label>
                                    <input name="city" value={formData.city || ''} onChange={handleChange} style={inputStyle} />
                                </div>
                            </div>
                            <div style={{ marginBottom: 16 }}>
                                <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.7, marginBottom: 4 }}>Email (Carte de visite)</label>
                                <input name="email" value={formData.email || ''} onChange={handleChange} style={inputStyle} />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginBottom: 20 }}>
                                <div>
                                    <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.7, marginBottom: 4 }}>Spécialité</label>
                                    <select name="specialty" value={formData.specialty || ''} onChange={handleChange} style={inputStyle}>
                                        <option value="">-</option>
                                        <option value="Expert Digital">Expert Digital</option>
                                        <option value="Chargé d'Affaires">Chargé d'Affaires</option>
                                    </select>
                                </div>
                                <div>
                                    <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.7, marginBottom: 4 }}>Niveau</label>
                                    <input
                                        type="number"
                                        name="level"
                                        className="no-spin"
                                        value={formData.level}
                                        onChange={handleChange}
                                        onWheel={(e) => e.currentTarget.blur()}
                                        onKeyDown={(e) => ["ArrowUp", "ArrowDown"].includes(e.key) && e.preventDefault()}
                                        style={inputStyle}
                                    />
                                </div>
                                <div>
                                    <label style={{ display: 'block', fontSize: '0.8rem', opacity: 0.7, marginBottom: 4 }}>XP</label>
                                    <input
                                        type="number"
                                        name="xp"
                                        className="no-spin"
                                        value={formData.xp}
                                        onChange={handleChange}
                                        onWheel={(e) => e.currentTarget.blur()}
                                        onKeyDown={(e) => ["ArrowUp", "ArrowDown"].includes(e.key) && e.preventDefault()}
                                        style={inputStyle}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                                <button type="button" onClick={handleClose} style={{ padding: '10px 20px', background: 'transparent', border: '1px solid var(--admin-border)', borderRadius: 8, color: 'inherit', cursor: 'pointer' }}>Annuler</button>
                                <button type="submit" style={{ padding: '10px 20px', background: '#3b82f6', border: 'none', borderRadius: 8, color: 'white', fontWeight: 600, cursor: 'pointer' }}>Enregistrer</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </AdminLayout>
    );
}

const inputStyle = {
    width: '100%', padding: '10px', background: 'rgba(0,0,0,0.05)', border: '1px solid var(--admin-border)', borderRadius: 6, color: 'inherit', fontSize: '0.9rem'
};
